import { render, staticRenderFns } from "./AlertaSistema.vue?vue&type=template&id=81bd9264&scoped=true&"
import script from "./AlertaSistema.vue?vue&type=script&lang=js&"
export * from "./AlertaSistema.vue?vue&type=script&lang=js&"
import style0 from "./AlertaSistema.vue?vue&type=style&index=0&id=81bd9264&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81bd9264",
  null
  
)

export default component.exports